import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Banner from '../home/Banner';
import HotDestinations from '../home/HotDestinations';
import AdBanner from '../home/AdBanner';
import Craft from '../home/Craft';
import Usp from '../home/Usp';
import CraftIndia from '../home/CraftIndia.js';
//import Trending from '../home/Trending';
import PopForm from '../home/PopForm';
import Reviews from '../home/Reviews';
import ContactForm from '../home/ContactForm';



export default function Home() {
  return (
    <>
      <Banner />
      <HotDestinations cls="col-md-4"/>
      <AdBanner />
      <Craft />
      <CraftIndia />
      <Usp />
      {/* <Trending /> */}
      <PopForm />
      <Reviews />
      <ContactForm />
    </>
  )
}
